module.exports = __webpack_public_path__ + "static/media/firstam_michel_logan.5b8383ff.jpg";